import { render, staticRenderFns } from "./PrtSidebar.vue?vue&type=template&id=27c01177&"
import script from "./PrtSidebar.js?vue&type=script&lang=js&"
export * from "./PrtSidebar.js?vue&type=script&lang=js&"
import style0 from "./PrtSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports